import styled from 'styled-components';

export const TopRightSection = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  justify-content: end;
  gap: 15px;
  position: relative;
`;
